import React, { useEffect, useState } from "react";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import api, { baseURL } from "../api";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFormattedNumbers from "../../hooks/useFormattedNumber";

const Schools = () => {
  const { i18n, t } = useTranslation();
  const [schools, setSchools] = useState([]);
  const [schoolPhotos, setSchoolPhotos] = useState([]);
  const [schoolVideos, setSchoolVideos] = useState([]);
  const numbers = schools.map((_, index) => index + 1);
  const formattedNumbers = useFormattedNumbers(numbers);
  const [activeTab, setActiveTab] = useState("photos");
  useEffect(() => {
    const lightbox = GLightbox({
      selector: ".glightbox",
    });

    return () => {
      lightbox.destroy();
    };
  }, [schoolPhotos]);

  const fetchSchools = async () => {
    try {
      const response = await api.get(`/schools?lang=${i18n.language}`);
      setSchools(response.data);
    } catch (error) {
      console.error("Error fetching school data");
    }
  };

  const fetchSchoolPhotos = async () => {
    try {
      const response = await api.get("/school-images");
      setSchoolPhotos(response.data);
    } catch (error) {
      console.error("Error fetching school images data");
    }
  };

  const fetchSchoolVideos = async () => {
    try {
      const response = await api.get(`/school-videos?lang=${i18n.language}`);
      setSchoolVideos(response.data);
    } catch (error) {
      console.error("Error fetching school videos");
    }
  };

  useEffect(() => {
    fetchSchools();
    fetchSchoolPhotos();
    fetchSchoolVideos();
    //eslint-disable-next-line
  }, [i18n.language]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const lightbox = GLightbox({
      selector: ".glightbox",
    });
  }, []);

  return (
    <div>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${innerBanner})` }}
        ></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("schools-contents.schools")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="#.">{t("cityProfile")}</Link>
              </li>
              <li>
                <span>{t("schools-contents.schools")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div id="main-content">
      <br />

      <section className="service-style-four mt-5 pb-1">
        <div className="auto-container">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="text-center">
                <tr>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("srNo")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("schools-contents.schoolNames")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("address")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("schools-contents.medium")}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#29aae1",
                      color: "#fff",
                    }}
                  >
                    {t("schools-contents.contact")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {schools.map((school, index) => (
                  <tr key={school.id}>
                    <td>{formattedNumbers[index]}</td>
                    <td>{school.schoolName}</td>
                    <td>{school.address}</td>
                    <td>{school.medium}</td>
                    <td>{school.contact}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <div className="auto-container mb-5">
        <div className="col-lg-12 col-md-12 col-sm-12 content-side">
          <div className="department-details-content">
            <div className="content-three">
              <div className="tabs-box">
                <div className="tab-btn-box">
                  <ul className="tab-btns tab-buttons clearfix">
                     <li className={`tab-btn ${activeTab === "photos" ? "active-btn" : ""}`}
                        onClick={() => setActiveTab("photos")}
                      >
                        {t("schools-contents.schoolsPhotoGallery")}
                      </li>

                      <li className={`tab-btn ${activeTab === "videos" ? "active-btn" : ""}`}
                        onClick={() => setActiveTab("videos")}
                      >
                        {t("schools-contents.schoolsVideos")}
                      </li>
                  </ul>
                </div>
                <div className="tabs-content">
                  <div className={`tab ${activeTab === "photos" ? "active-tab" : ""}`} id="tab-1">
                    <div className="content-box">
                      <div className="content-box department-section">
                        <div className="row">
                          {schoolPhotos.map((image, index) => (
                            <Link
                              to={`${baseURL}${image.image_path}`}
                              className="glightbox col-sm-2"
                              data-gallery="slider-images"
                            >
                              <img
                                src={`${baseURL}${image.image_path}`}
                                alt={`img${index + 1}`}
                                className="img-fluid"
                              />
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`tab ${activeTab === "videos" ? "active-tab" : ""}`} id="tab-2">
                    <div className="content-box">
                      <div className="row">
                        {schoolVideos.map((video) => (
                          <div
                            className="col-lg-4 col-md-6 mb-4"
                            key="video.id"
                          >
                            <div className="card shadow-sm">
                              <iframe
                                width="100%"
                                height="220"
                                src={video.youtube_url}
                                title="{video.title}"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>

                              {/*<div className="card-body">
                                <h6>{video.title}</h6>
                              </div>*/}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Schools;
